<template>
  <nav style="z-index: 3">
    <v-toolbar color="white" height="60">
      <v-img
        alt="Logo"
        class="shrink app"
        contain
        :src="images.logo"
        transition="scale-transition"
        width="90"
      />
      <p
        style="
          color: #23241f;
          margin-left: 1rem;
          font-size: 18px;
          margin-top: 14px;
          font-weight: bold;
          cursor: default;
        "
      >
        {{ $t("message.ParkingRedemption") }}
        <!-- Parking Validation -->
      </p>
      <v-spacer></v-spacer>
      <v-img
        v-show="$i18n.locale == 'en'"
        class="shrink"
        contain
        src="@/assets/united-kingdom.png"
        @click="SwitchLocales('en')"
        style="padding-right: 65px; cursor: pointer"
        width="35"
        height="35"
      />
      <v-img
        v-show="$i18n.locale == 'th'"
        class="shrink"
        contain
        src="@/assets/thailand.png"
        @click="SwitchLocales('th')"
        style="padding-right: 65px; cursor: pointer"
        width="35"
        height="35"
      />
      <v-menu offset-y>
        <template v-slot:activator="{ on: menu }">
          <v-btn icon v-on="{ ...menu }">
            <v-icon color="#126496">mdi-menu-down</v-icon>
          </v-btn>
          <div>
            <span style="font-size: 15px; color: black; padding-right: 15px">{{
              Username
            }}</span>
          </div>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in itemsMenu" :key="index">
            <v-list-item-title
              style="cursor: pointer"
              @click="ActionMenu(item.title)"
              >{{ item.title }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear
              indeterminate
              color="#ffffff"
              class="mb-0"
            ></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="EditUserDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>Edit User</p>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            icon
            @click="CloseEditUserDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="ml-5 mr-2">
            <v-col cols="12" md="6">
              <p style="font-size: 16px; color: black">Username</p>
              <v-text-field
                disabled
                solo
                placeholder="Username"
                v-model="EditUsername"
              />
            </v-col>
            <v-col cols="12" md="6">
              <p style="font-size: 16px; color: black">Password <span style="color: red; font-size: 13px;"> * กรอกรหัสผ่าน 4 - 10 ตัวอักษร</span></p>
              <v-text-field
                solo
                placeholder="Password"
                type="password"
                id="password"
                v-model="EditPassword"
                :append-icon="flagPasswordEditUser ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="TogglePassword"
              />
            </v-col>
          </v-row>
          <v-row class="ml-5 mr-2">
            <v-col cols="12" md="6">
              <p style="font-size: 16px; color: black">FirstName</p>
              <v-text-field
                solo
                placeholder="FirstName"
                v-model="EditFirstName"
                disabled
              />
            </v-col>
            <v-col cols="12" md="6">
              <p style="font-size: 16px; color: black">LastName</p>
              <v-text-field
                solo
                placeholder="LastName"
                v-model="EditLastName"
                disabled
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6"></v-col>
            <v-col cols="12" md="6" align="right">
              <v-btn
                height="40"
                width="120"
                color="success"
                outlined
                @click="UpdateRedemptionUser()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
              <v-btn
                height="40"
                width="120"
                color="red"
                outlined
                @click="CloseEditUserDialog()"
              >
                {{ $t("message.Cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import axios from "axios";
import store from "../store";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
  data() {
    return {
      MenuSystemList: [],
      url: enurl.apiUrl,
      PositionID: null,
      LoadingDialog: false,
      show: false,
      Username: localStorage.getItem("Username"),
      usertype: store.state.usertype,
      drawer: null,
      images: {
        logo: require("@/assets/logo.png"),
      },
      currentflag: "en",
      languages: [
        { flag: "us", language: "en", title: "English" },
        { flag: "th", language: "th", title: "ไทย" },
      ],
      users: [],
      LogoImageString: "",
      ActiveStatus: false,

      EditUserDialog: false,
      flagPasswordEditUser: false,
      itemsMenu: [{ title: "Change Password" }, { title: "Logout" }],
      EditUserID: null,
      EditUsername: "",
      EditPassword: "",
      EditFirstName: "",
      EditLastName: "",
    };
  },

  mounted() {
    this.SwitchLocales("th");
    this.LoadDataSettingLogin();
  },

  methods: {
    LoadDataSettingLogin() {
      let self = this;
      axios
        .get(`${self.url}Setting/LoadDataSettingLogin`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.LogoImageString = response.data.data.logoImageString;
              self.ActiveStatus = response.data.data.activeStatus;
            }
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    SwitchLocales(value) {
      let self = this;
      if (value == "en") {
        self.$i18n.locale = "th";
      } else {
        self.$i18n.locale = "en";
      }
    },

    Logout() {
      localStorage.clear();
      this.$router.push("/Login");
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.flagPasswordEditUser = false;
      } else {
        x.type = "password";
        self.flagPasswordEditUser = true;
      }
    },

    ActionMenu(data) {
      let self = this;
      if (data == "Change Password") {
        self.EditUser();
      } else {
        self.Logout();
      }
    },

    EditUser() {
      let self = this;
      var id = parseInt(localStorage.getItem("UserID"));
      self.GetDataRedemptionUser(id);
    },

    MappingEditUser(data) {
      let self = this;
      self.EditUserID = data.login_id;
      self.EditUsername = data.username;
      self.EditPassword = data.password;
      self.EditFirstName = data.userFname;
      self.EditLastName = data.userLname;
      self.EditUserDialog = true;
    },

    CloseEditUserDialog() {
      let self = this;
      self.EditUserID = null;
      self.EditPassword = "";
      self.EditFirstName = "";
      self.EditLastName = "";
      self.EditUserDialog = false;
    },

    GetDataRedemptionUser(id) {
      let self = this;
      let temp = {
        UserID: id,
      };
      axios
        .post(`${self.url}Login/GetDataRedemptionUser`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.MappingEditUser(response.data.data);
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    UpdateRedemptionUser() {
      let self = this;
      let temp = {
        UserID: self.EditUserID,
        Password: self.EditPassword,
        FirstName: self.EditFirstName,
        LastName: self.EditLastName,
      };
      axios
        .post(`${self.url}Login/UpdateRedemptionUser`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              self.Logout();
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
};
</script>
<style>
.app {
  margin-left: 1rem;
  cursor: pointer;
}
.list {
  cursor: pointer;
}
.apptitle {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.v-list-item__content {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.mdi-menu-down::before {
  color: black;
}
.white-color {
  background-color: red;
  color: red;
}
.item-title {
  font-size: 16px;
  font-weight: 500;
}
.v-application--is-ltr
  .v-list-group--no-action.v-list-group--sub-group
  .v-list-group__items
  .v-list-item {
  padding-left: 20px !important;
}
</style>
